var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplateHelper = function SvgTemplateHelper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -85.46,
    y1: 138.92,
    x2: 143.69,
    y2: -44.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -86.18,
    y1: 138.02,
    x2: 142.97,
    y2: -45.31,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -58.72,
    y1: 172.34,
    x2: 170.43,
    y2: -10.98,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -53.78,
    y1: 178.51,
    x2: 175.37,
    y2: -4.81,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -50.29,
    y1: 182.88,
    x2: 178.87,
    y2: -0.44,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -51.01,
    y1: 181.98,
    x2: 178.14,
    y2: -1.34,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -23.55,
    y1: 216.31,
    x2: 205.6,
    y2: 32.98,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -18.61,
    y1: 222.48,
    x2: 210.54,
    y2: 39.16,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -15.12,
    y1: 226.85,
    x2: 214.04,
    y2: 43.52,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -15.84,
    y1: 225.94,
    x2: 213.31,
    y2: 42.62,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 11.62,
    y1: 260.27,
    x2: 240.77,
    y2: 76.95,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 16.56,
    y1: 266.44,
    x2: 245.71,
    y2: 83.12,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.31,0c-15.39,0-27.92,12.52-27.92,27.92s12.52,27.88,27.92,27.88,27.92-12.51,27.92-27.88S68.71,0,53.31,0ZM53.31,49.55c-11.95,0-21.67-9.7-21.67-21.63,0-11.95,9.72-21.67,21.67-21.67s21.67,9.72,21.67,21.67-9.72,21.63-21.67,21.63Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,19.77l-9.63,9.63-3.11-3.11c-1.22-1.22-3.2-1.22-4.42,0-1.22,1.22-1.22,3.2,0,4.42l5.32,5.32c.59.59,1.38.92,2.21.92s1.62-.33,2.21-.92l11.84-11.84c1.22-1.22,1.22-3.2,0-4.42-1.22-1.22-3.2-1.22-4.42,0Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71,20.81h73.77c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13h-73.77c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71,41.24h48.03c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13h-48.03c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31,72.1c-15.39,0-27.92,12.52-27.92,27.92,0,15.37,12.52,27.88,27.92,27.88s27.92-12.51,27.92-27.88-12.52-27.92-27.92-27.92ZM53.31,121.65c-11.95,0-21.67-9.7-21.67-21.63,0-11.95,9.72-21.67,21.67-21.67s21.67,9.72,21.67,21.67-9.72,21.63-21.67,21.63Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,91.87l-9.63,9.63-3.11-3.11c-1.22-1.22-3.2-1.22-4.42,0-1.22,1.22-1.22,3.2,0,4.42l5.32,5.32c.61.61,1.41.92,2.21.92s1.6-.31,2.21-.92l11.84-11.84c1.22-1.22,1.22-3.2,0-4.42-1.22-1.22-3.2-1.22-4.42,0Z",
    style: {
      fill: "url(#g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,86.66h-73.77c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13h73.77c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13Z",
    style: {
      fill: "url(#h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71,113.34h48.03c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13h-48.03c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13Z",
    style: {
      fill: "url(#i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31,144.2c-15.39,0-27.92,12.52-27.92,27.92,0,15.37,12.52,27.88,27.92,27.88s27.92-12.51,27.92-27.88-12.52-27.92-27.92-27.92ZM53.31,193.75c-11.95,0-21.67-9.7-21.67-21.63,0-11.95,9.72-21.67,21.67-21.67s21.67,9.72,21.67,21.67-9.72,21.63-21.67,21.63Z",
    style: {
      fill: "url(#j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,163.97l-9.63,9.63-3.11-3.11c-1.22-1.22-3.2-1.22-4.42,0-1.22,1.22-1.22,3.2,0,4.42l5.32,5.32c.61.61,1.41.92,2.21.92s1.6-.31,2.21-.92l11.84-11.84c1.22-1.22,1.22-3.2,0-4.42-1.22-1.22-3.2-1.22-4.42,0Z",
    style: {
      fill: "url(#k)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,158.76h-73.77c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13h73.77c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13Z",
    style: {
      fill: "url(#l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.74,179.19h-48.03c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13h48.03c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13Z",
    style: {
      fill: "url(#m)",
      strokeWidth: 0
    }
  }));
};
export default SvgTemplateHelper;